export const SCROLLABLE_TABLE = {
  CELLS: {
    badge: 56,
    live: 56,
    competitorMin: 100
  },

  SHADOWS: {
    firstMaxWidth: 5,
    lastMaxWidth: 45,
  },

  PTS_KEY: "points",
  NO_POSITION: -1,
  MENU_BAR_DELAY: 250
}
